import { ClientHandler } from '../../../types';

export const resumidoHandler: ClientHandler = {
  cleanFormData: (formData, creativityType) => {
    const { title, _creativityType, ...config } = formData;
    return config;
  }
};
